import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ICmsClientModule } from '@icms/client/icms-client.module';
import { ICmsComponent, ICmsContent, NICmsContentComponent, NICmsContentField } from '@icms/core/content';
import { AbstractCmsBlockComponent } from '../cms/block/abstract-cms-block.component';

export interface ICheckoutMiniBasketContentBlock extends NICmsContentComponent.IData {
    copy?: string;
}

@Component({
    selector: 'checkout-minibasket-content-block',
    templateUrl: './checkout-minibasket-content-block.component.html',
    styleUrl: './checkout-minibasket-content-block.component.scss',
    standalone: true,
    imports: [ICmsClientModule],
    changeDetection: ChangeDetectionStrategy.OnPush
})
@ICmsComponent<CheckoutMinibasketContentBlockComponent>({
    id: 'checkout-minibasket-content-block',
    block: {
        url: 'checkout-minibasket-content-block'
    },
    onDemandOnly: true,
    name: 'Checkout minibasket content block',
    description: 'Content block used on the checkout minibasket page',
    fields: [
        {
            type: NICmsContentField.EFieldType.label,
            key: 'section-general',
            title: 'Checkout minibasket content'
        },
        {
            key: 'copy',
            type: NICmsContentField.EFieldType.text,
            title: 'Copy',
            default: 'Free delivery for all orders available'
        }
    ]
})
export class CheckoutMinibasketContentBlockComponent extends AbstractCmsBlockComponent implements NICmsContentComponent.IComponent {
    @ICmsContent({
        type: 'blockContent'
    })
    override content!: ICheckoutMiniBasketContentBlock;

    override canDetach = false;
}
